import styled from "styled-components/macro";
import {
  colors,
  space,
  borderRadius,
  breakpoint,
} from "shared/styles/constants";
import { IFormFieldStyle } from "shared/types";

export const StyledTitle = styled.span`
  display: block;
  margin-bottom: ${space.m};
`;

export interface StyledFieldsetProps {
  style?: IFormFieldStyle;
  hideContainer?: boolean;
}

export const StyledFieldset = styled.fieldset<StyledFieldsetProps>`
  ${({ hideContainer }) =>
    !hideContainer &&
    `
    background-color: ${colors.grey2};
    border-radius: ${borderRadius.m};

    padding: ${space.m};

    grid-column: 1/3;
  `}

  ${breakpoint("s", "down")} {
    ${({ style }) => {
      if (style?.mobile) {
        const { gridColumn } = style.mobile;

        return `
            ${gridColumn ? `grid-column: ${gridColumn} !important;` : ""}
          `;
      }
    }}
  }
`;

export const FlexChildren = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;

  width: fit-content;

  > * {
    width: auto;
  }
`;

export const StyledSeparator = styled.div`
  padding: ${space.s} ${space.s};
`;

export const GridChildren = styled.div<StyledFieldsetProps>`
  display: grid;
  grid-gap: ${space.m} ${space.s};

  ${breakpoint("s", "down")} {
    ${({ style }) => {
      if (style?.mobile) {
        const { gridTemplateColumns, gridTemplateRows } = style.mobile;

        return `
            ${
              gridTemplateColumns
                ? `grid-template-columns: ${gridTemplateColumns} !important;`
                : ""
            }
            
            ${
              gridTemplateRows
                ? `grid-template-rows: ${gridTemplateRows} !important;`
                : ""
            }
          `;
      }

      return `grid-template-columns: 1fr !important;`; // override formData styles
    }}
  }
`;
